import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { submissionsApi } from '@api';
import { AdditionalDemand } from '@app-types';

const useSendRequestedDocuments = (
  id: string | undefined,
  options?: UseMutationOptions<AxiosResponse, unknown, AdditionalDemand[]>,
) => {
  return useMutation({
    ...options,
    mutationFn: (data) => {
      return submissionsApi.sendRequestedDocuments({ id, data });
    },
  });
};

export default useSendRequestedDocuments;
